import { render, staticRenderFns } from "./SleepMattresslist.vue?vue&type=template&id=791a2e86&scoped=true"
import script from "./SleepMattresslist.vue?vue&type=script&lang=js"
export * from "./SleepMattresslist.vue?vue&type=script&lang=js"
import style0 from "./SleepMattresslist.vue?vue&type=style&index=0&id=791a2e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a2e86",
  null
  
)

export default component.exports